module.exports = __webpack_public_path__ + "static/media/optHeartOpener.a454ad3b.jpg";